module.exports = __webpack_public_path__ + "fonts/nationale-regular.be32ff3.eot";